exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5795c98a] .el-table th > .cell {\n  text-align: center;\n  font-size: 11px;\n}\n[data-v-5795c98a] .el-table td > .cell {\n  font-size: 11px;\n}\n.data-arrive[data-v-5795c98a] {\n  padding: 7px;\n  border-radius: 5px;\n  background: yellowgreen;\n}\n.data-eat[data-v-5795c98a] {\n  padding: 7px;\n  border-radius: 5px;\n  background: #ddbd52;\n}\n", ""]);

// exports
